/**
 * <SelectTheme 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './SelectTheme.scss';

// temp
import theme1 from './images/theme1.jpg';

class SelectTheme extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    return (
      <div className='SelectTheme'>
        <ul className='SelectTheme--list'>
          <li className={classnames('SelectTheme--item', 'selected')}> 
            <div className='SelectTheme--image' style={{backgroundImage: `url(${theme1})`}}></div>
          </li>
        </ul>
      </div>
    )
  }
}

export default SelectTheme;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/SelectTheme/index.js